var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9375mm",
    height: "10.583mm",
    viewBox: "0 0 7.9375 10.583333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-224.33 -367.3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 669 522.69)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1680.6-587.31h30v40h-30z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.4393)",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1677.1-550.97 14.652-28.005h-18.252v-4.6712h25.202v1.4128l-16.201 31.263z",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.1a54d84da973ab77cc974c617c0e7051.svg";
export { ForwardRef as ReactComponent };